import { Helmet } from 'react-helmet-async';

import { useTenant } from '@/hooks/useTenant';

interface Props {
  title: string;
  children?: React.ReactNode;
}
export const MetaData = (props: Props) => {
  const { title, children } = props;

  const tenant = useTenant();

  return (
    <Helmet>
      <title>
        {title} | {tenant.marketplaceName}
      </title>
      <meta name="description" content={tenant.marketplaceDesc ?? ''} />
      {children}
    </Helmet>
  );
};
